import { SET_MAINTENANCE } from 'app-redux/actionTypes'

export const setMaintenance = (payload) => {
  return {
    type: SET_MAINTENANCE,
    payload,
  }
}
